const atcForm = document.querySelector('form[action="/cart/add"]');
const atcButton = document.querySelector('.product-form--atc-button');
if (atcButton) {
  atcButton.addEventListener('click', (event) => {
    event.preventDefault();
    addItemToCart(event.currentTarget);
  });
}

// Variant selection functionality
document.addEventListener('DOMContentLoaded', () => {
  initVariantSelectors();
});

function initVariantSelectors() {
  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  // Get product JSON from the script tag
  const productJsonScript = document.querySelector('[data-section-type="static-product"][data-section-data]');
  if (!productJsonScript) return;

  try {
    const productData = JSON.parse(productJsonScript.textContent);
    const product = productData.product;
    const variants = product.variants;

    // Find all option selectors (both dropdowns and radio buttons)
    const optionSelectors = productForm.querySelectorAll('[data-product-option]');
    
    // Add change event listeners to all option selectors
    optionSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        updateSelectedVariant(productForm, product, variants, productData);
      });
    });

    // Initialize with the current selection
    updateSelectedVariant(productForm, product, variants, productData, true);
  } catch (error) {
    console.error('Error initializing variant selectors:', error);
  }
}

$(document).ready(function(){

    $(document).on('change','.product-optionsg-1 select',function(){
      getSecondOptions();
    })
    function getSecondOptions(){
  var url = window.location.href;
  console.log(url)
  $.ajax({
    url: url+'&section_id=product-template',   // URL jahan se data lena hai
    type: 'GET',
    success: function(response) {
      var sectionOptions = $(response).find('.product-optionsg-2 select').html();
      if( sectionOptions == undefined ){
          sectionOptions = $(response).filter('.product-optionsg-2 select').html();
      }
      $(document).find('.product-optionsg-2 select').html(sectionOptions);
      setTimeout(function(){
        var $firstAvailable = $(document).find('.product-optionsg-2 select').find('option.avail').first();

          if ($firstAvailable.length) {
            $(document).find('.product-optionsg-2 select').val($firstAvailable.val()).trigger('change');
             const productForm = document.querySelector('[data-product-form]');
              if (!productForm) return;
            
              // Get product JSON from the script tag
              const productJsonScript = document.querySelector('[data-section-type="static-product"][data-section-data]');
              if (!productJsonScript) return;
            const productData = JSON.parse(productJsonScript.textContent);
            const product = productData.product;
            const variants = product.variants;
            updateSelectedVariant(productForm, product, variants, productData)
          }
      },100)
    },
    error: function(xhr, status, error) {
      console.error('Error:', error);
    }
  });
}
    
  })



function updateSelectedVariant(form, product, variants, productData, initial) {
  // Get the currently selected options
  const selectedOptions = [];
  const optionSelectors = form.querySelectorAll('[data-product-option]');
  
  optionSelectors.forEach(selector => {
    const optionIndex = parseInt(selector.getAttribute('data-product-option'), 10);
    
    // Handle both select dropdowns and radio buttons
    let optionValue;
    if (selector.tagName === 'SELECT') {
      optionValue = selector.value;
    } else if (selector.tagName === 'INPUT' && selector.type === 'radio' && selector.checked) {
      optionValue = selector.value;
    }
    
    if (optionValue) {
      selectedOptions[optionIndex] = optionValue;
    }
  });

  // Make sure all options are selected
  if (selectedOptions.length === product.options.length && !selectedOptions.includes(undefined)) {
    // Find the matching variant
    const matchingVariant = variants.find(variant => {
      return product.options.every((option, index) => {
        return variant.options[index] === selectedOptions[index];
      });
    });

    if (matchingVariant) {
      // Update the variant ID input/select
      const variantIdElement = form.querySelector('input[name="id"], select[name="id"]');
      if (variantIdElement) {
        variantIdElement.value = matchingVariant.id;
      }

      // Update price - try multiple selectors to find the price element.
      // .pdp-price-amount is FIRST so we replace only the price span and preserve the sibling
      // .pdp-stock-indicator badge (+ price-per) that Liquid rendered inside .atc-info--price.
      const priceSelectors = [
        '.pdp-price-amount',
        '.atc-info--price',
        '.product__price',
        '[data-product-price]',
        '.product-price'
      ];
      
      let priceElement = null;
      for (const selector of priceSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          priceElement = element;
          break;
        }
      }
      
      if (priceElement && matchingVariant.price) {
        // Format price according to Shopify's money format
        const moneyFormat = productData?.settings?.money_format || "${{amount}}";
        const formattedPrice = formatMoney(matchingVariant.price, moneyFormat);
        
        // Log for debugging
        console.log('Updating price to:', formattedPrice);
        
        // Update the price element
        priceElement.innerHTML = formattedPrice;
      } else {
        console.log('Price element not found or variant has no price');
      }

      // Update the PDP stock badge (this theme uses .pdp-stock-indicator, next to the price).
      try {
        const pdpBadge = document.querySelector('.atc-wrapper .pdp-stock-indicator');
        if (pdpBadge) {
          const q = matchingVariant.inventory_quantity;
          const managed = matchingVariant.inventory_management;
          const cap = 999;
          const ICO_CHECK = '<svg class="pdp-stock-ico" width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><path d="M11.9173 6.00151V6.49984C11.9167 7.66791 11.5384 8.80446 10.839 9.74C10.1397 10.6755 9.1566 11.3599 8.03647 11.6911C6.91634 12.0223 5.71917 11.9825 4.62349 11.5777C3.52781 11.1729 2.59234 10.4248 1.95659 9.44492C1.32084 8.46503 1.01887 7.30588 1.09573 6.14035C1.17258 4.97482 1.62414 3.86536 2.38305 2.97743C3.14197 2.0895 4.16758 1.47068 5.30692 1.21326C6.44626 0.955838 7.6383 1.07361 8.70524 1.54901M11.9173 2.16651L6.50065 7.5886L4.87565 5.9636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          const ICO_X = '<svg class="pdp-stock-ico" width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><circle cx="6.5" cy="6.5" r="5.5" stroke-width="2"/><path d="M4.6 4.6l3.8 3.8M8.4 4.6l-3.8 3.8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          let ico = ICO_CHECK, text, cls = '';
          if (matchingVariant.available) {
            if (managed == null || managed === '' || q > 10) {
              text = q > 0 ? ((q >= cap ? cap + '+' : q) + ' in stock') : 'In stock';
            } else if (q > 0) {
              text = 'Only ' + q + ' left'; cls = 'low';
            } else {
              text = 'In stock';
            }
          } else {
            ico = ICO_X; text = 'Out of stock'; cls = 'oos';
          }
          pdpBadge.className = 'pdp-stock-indicator' + (cls ? ' ' + cls : '');
          pdpBadge.innerHTML = ico + text;
        }
      } catch (e) { /* leave the server-rendered badge as-is */ }

      // Update stock level text
      const stockLevelText = document.querySelector('.stock-level--text');
      if (stockLevelText) {
        console.log('Variant inventory status:', {
          title: matchingVariant.title,
          available: matchingVariant.available,
          inventory_quantity: matchingVariant.inventory_quantity,
          inventory_policy: matchingVariant.inventory_policy
        });
        
        // Get the parent element that contains both the icon and text
        const stockLevelWrapper = stockLevelText.closest('.product--stock-level') || 
                                  stockLevelText.closest('.stock-level--wrapper');
        
        if (stockLevelWrapper) {
          // First, remove all stock-related classes to start fresh
          stockLevelWrapper.classList.remove(
            'stock-level--in-stock', 
            'stock-level--low-stock', 
            'stock-level--no-stock',
            'stock-level--out-of-stock'
          );
          
          if (matchingVariant.available) {
            if (matchingVariant.inventory_quantity > 10) {
              stockLevelText.textContent = `${matchingVariant.inventory_quantity} In stock`;
              stockLevelWrapper.classList.add('stock-level--in-stock');
            } else if (matchingVariant.inventory_quantity > 0) {
              stockLevelText.textContent = `Only ${matchingVariant.inventory_quantity} left!`;
              stockLevelWrapper.classList.add('stock-level--low-stock');
            } else if (matchingVariant.inventory_policy === 'continue') {
              stockLevelText.textContent = 'Available for backorder';
              stockLevelWrapper.classList.add('stock-level--in-stock');
            } else {
              // Default in-stock message if we can't determine specifics
              stockLevelText.textContent = 'In stock';
              stockLevelWrapper.classList.add('stock-level--in-stock');
            }
          } else {
            stockLevelText.textContent = 'Sold out';
            stockLevelWrapper.classList.add('stock-level--no-stock');
          }
          
          // Remove any custom styling we added previously
          if (document.getElementById('stock-level-styles')) {
            document.getElementById('stock-level-styles').remove();
          }
        } else {
          console.log('Stock level wrapper not found');
        }
        
        console.log('Updated stock level text for variant:', matchingVariant.title, 'to:', stockLevelText.textContent);
      }

      // Update availability
      const atcButton = form.querySelector('.product-form--atc-button');
      const atcButtonText = atcButton?.querySelector('.atc-button--text');
      
      if (atcButton && atcButtonText) {
        if (matchingVariant.available) {
          atcButton.classList.remove('disabled');
          atcButton.removeAttribute('disabled');
          atcButtonText.textContent = window.theme?.translations?.addToCart || 'Add to cart';
        } else {
          atcButton.classList.add('disabled');
          atcButton.setAttribute('disabled', 'disabled');
          atcButtonText.textContent = window.theme?.translations?.soldOut || 'Sold out';
        }
      }

      // Update SKU if displayed
      const skuElement = document.querySelector('[data-product-sku]');
      if (skuElement && matchingVariant.sku) {
        skuElement.textContent = matchingVariant.sku;
      }

      // Update URL with variant ID if history enabled. Not on load: GA4 and the Ads tag
      // count that rewrite as a second page_view.
      if (!initial && productData?.settings?.enableHistory) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  let value = '';

  const match = formatString.match(placeholderRegex);
  if (match) {
    const type = match[1];
    switch (type) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

async function getShopifyCartItemQty() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cartData = await response.json();
    let totalQuantity = 0;
    for (let item of cartData.items) {
      return item.quantity;        
    }

    return totalQuantity;
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

function toggleAtcSpinner(show, trigger) {
  const atcBtn =
    trigger ||
    document.querySelector('.product-form--atc-button') ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('button[type="submit"]');

  if (!atcBtn) return;

  if (show) {
    atcBtn.classList.add('processing');
    atcBtn.setAttribute('disabled', 'disabled');
  } else {
    atcBtn.classList.remove('processing');
    atcBtn.removeAttribute('disabled');
  }
}

function showErrorMessage(message) {
  const siteHeader = document.querySelector('header.site-header') || document.body;
  if (!siteHeader) {
    alert(message);
    return;
  }
  siteHeader.insertAdjacentHTML('beforeend',
    `<div class="message-banner--container message--error visible" role="alert" data-message-banner="">
      <div class="message-banner--outer">
        <div class="message-banner--inner" data-message-banner-content="">${message}</div>
        <button class="message-banner--close" type="button" aria-label="Close" data-message-banner-close="">      
          <svg class="icon-menu-close " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">          <title>Close icon</title>        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 7.73744L1.61872 12.6187L0.381283 11.3813L5.26256 6.50001L0.381283 1.61872L1.61872 0.381287L6.5 5.26257L11.3813 0.381287L12.6187 1.61872L7.73744 6.5L12.6187 11.3813L11.3813 12.6187L6.5 7.73744Z" fill="currentColor"></path>    </svg>                                                
        </button>
      </div>
    </div>`
  );
  // const errMsgContainer = document.querySelector('.message-banner--container');
  // const errMsgInner = errMsgContainer.querySelector('.message-banner--inner');
  // errMsgContainer.classList.add('message--error','visible');
  // errMsgInner.textContent = message;
}

async function updateCartIconQty() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    });
    const cart = await response.json();

    document
      .querySelectorAll('[data-header-cart-count], .site-header-cart--count, .site-header-cart-count, .cart-count')
      .forEach(function (el) {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count;
          el.classList.add('visible');
          el.dataset.headerCartCount = cart.item_count;
          el.setAttribute('data-header-cart-count', cart.item_count);
        } else {
          el.textContent = '';
          el.classList.remove('visible');
          el.dataset.headerCartCount = '';
          el.setAttribute('data-header-cart-count', '');
        }
      });

    document.querySelectorAll('.c_value').forEach(function (el) {
      const msg = el.querySelector('.c_msg');
      if (msg && window.Shopify && typeof Shopify.formatMoney === 'function') {
        el.innerHTML = msg.outerHTML + Shopify.formatMoney(cart.total_price);
      }
    });

    return cart;
  } catch (error) {
    console.error('Error updating cart icon:', error);
    return null;
  }
}


function getPdpCartForm(trigger) {
  return (
    trigger?.closest('form[action*="/cart/add"]') ||
    trigger?.closest('form[data-product-form]') ||
    trigger?.closest('[data-product-form]') ||
    trigger?.closest('.product-form') ||
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[data-product-form]') ||
    document.querySelector('[data-product-form]') ||
    document.querySelector('form.product-form')
  );
}

function getPdpVariantId(trigger) {
  const form = getPdpCartForm(trigger);

  const variantInput =
    form?.querySelector('input[name="id"]:not([disabled])') ||
    form?.querySelector('select[name="id"]:not([disabled])') ||
    document.querySelector('.atc-wrapper input[name="id"]:not([disabled])') ||
    document.querySelector('.atc-wrapper select[name="id"]:not([disabled])') ||
    document.querySelector('input[name="id"]:not([disabled])') ||
    document.querySelector('select[name="id"]:not([disabled])');

  if (variantInput && variantInput.value) {
    return variantInput.value;
  }

  const urlVariant = new URLSearchParams(window.location.search).get('variant');
  return urlVariant || null;
}

function getPdpQuantity(trigger) {

  const container =
    // Boost AI leftover, Boost is off: trigger?.closest('.boost-sd__quick-view') ||
    trigger?.closest('form') ||
    document;

  /*
    Standard Shopify quantity inputs
  */
  let quantityInput =
    container.querySelector('input[name="quantity"]') ||
    container.querySelector('select[name="quantity"]');

  // Boost AI leftover, Boost is off: Boost quickshop quantity input
  // if (!quantityInput) {
  //   quantityInput =
  //     container.querySelector('.boost-sd__input-number-input');
  // }

  /*
    Final quantity
  */
  const quantity =
    quantityInput && quantityInput.value
      ? parseInt(quantityInput.value, 10)
      : 1;

  return quantity > 0 ? quantity : 1;
}

function openCartDrawerOrFallback() {
  const drawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('[data-cart-drawer]') ||
    document.querySelector('[data-cart-drawer-container]') ||
    document.querySelector('.cart-drawer') ||
    document.querySelector('#cart-drawer') ||
    document.querySelector('.ajax-cart') ||
    document.querySelector('[data-ajax-cart]');

  const trigger =
    document.querySelector('[data-cart-drawer-open]') ||
    document.querySelector('[data-cart-drawer-toggle]') ||
    document.querySelector('[data-cart-toggle]') ||
    document.querySelector('[data-mini-cart-trigger]') ||
    document.querySelector('[data-ajax-cart-trigger]') ||
    document.querySelector('.site-header-cart-button');

  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }

  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
    return true;
  }

  if (drawer) {
    drawer.classList.add('is-open', 'active', 'visible', 'drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open', 'cart-open', 'drawer-open');
    return true;
  }

  if (trigger) {
    trigger.click();
    return true;
  }

  return false;
}

function addItemToCart(trigger) {
  toggleAtcSpinner(true, trigger);

  const productVariantId = getPdpVariantId(trigger);
  const quantity = getPdpQuantity(trigger);

  if (!productVariantId) {
    console.error('Add to cart failed: variant ID not found.');
    showErrorMessage('Please select an available product option before adding to cart.');
    toggleAtcSpinner(false, trigger);
    return;
  }

  const formData = {
    items: [
      {
        id: Number(productVariantId),
        quantity: Number(quantity)
      }
    ]
  };

  fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status >= 300) {
          throw data;
        }
        return data;
      });
    })
    .then(function (data) {
      console.log('add to cart success data', data);

      return updateCartIconQty().then(function () {
        // Open cart drawer/mini-cart if available. If no drawer exists, it stays on the page.
        openCartDrawerOrFallback();

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      });
    })
    .catch(function (error) {
      console.error('Add to cart error:', error);
      showErrorMessage(error?.message || error?.description || 'Unable to add item to cart.');
    })
    .finally(function () {
      toggleAtcSpinner(false, trigger);
    });
}

// Separate function to update stock level text that can be called by the MutationObserver
function updateStockLevelText(variant) {
  const stockLevelText = document.querySelector('.stock-level--text');
  if (!stockLevelText) return;
  
  console.log('Updating stock level for variant:', {
    title: variant.title,
    available: variant.available,
    inventory_quantity: variant.inventory_quantity,
    inventory_policy: variant.inventory_policy
  });
  
  // Get the parent element that contains both the icon and text
  const stockLevelWrapper = stockLevelText.closest('.product--stock-level') || 
                            stockLevelText.closest('.stock-level--wrapper');
  
  if (stockLevelWrapper) {
    // First, remove all stock-related classes to start fresh
    stockLevelWrapper.classList.remove(
      'stock-level--in-stock', 
      'stock-level--low-stock', 
      'stock-level--no-stock',
      'stock-level--out-of-stock'
    );
    
    if (variant.available) {
      // Check if inventory_quantity is defined and valid
      const hasInventoryCount = typeof variant.inventory_quantity === 'number' && !isNaN(variant.inventory_quantity);
      
      if (hasInventoryCount && variant.inventory_quantity > 10) {
        // Instead of just changing the text content, use a more robust approach
        // 1. Create a custom element to show the inventory count
        const inventoryCountSpan = document.createElement('span');
        inventoryCountSpan.className = 'inventory-count';
        inventoryCountSpan.textContent = variant.inventory_quantity + ' ';
        
        // 2. Clear the stock level text and add our custom element first
        stockLevelText.textContent = '';
        stockLevelText.appendChild(inventoryCountSpan);
        
        // 3. Add the "In stock" text after our count
        const stockTextNode = document.createTextNode('In stock');
        stockLevelText.appendChild(stockTextNode);
        
        // 4. Add appropriate class
        stockLevelWrapper.classList.add('stock-level--in-stock');
        
        // 5. Store the inventory count for reference
        stockLevelWrapper.setAttribute('data-inventory-count', variant.inventory_quantity);
      } else if (hasInventoryCount && variant.inventory_quantity > 0) {
        // For low stock, use the same approach
        const inventoryCountSpan = document.createElement('span');
        inventoryCountSpan.className = 'inventory-count';
        inventoryCountSpan.textContent = 'Only ' + variant.inventory_quantity + ' ';
        
        stockLevelText.textContent = '';
        stockLevelText.appendChild(inventoryCountSpan);
        
        const stockTextNode = document.createTextNode('left!');
        stockLevelText.appendChild(stockTextNode);
        
        stockLevelWrapper.classList.add('stock-level--low-stock');
        stockLevelWrapper.setAttribute('data-inventory-count', variant.inventory_quantity);
      } else if (variant.inventory_policy === 'continue') {
        stockLevelText.textContent = 'Available for backorder';
        stockLevelWrapper.classList.add('stock-level--in-stock');
        stockLevelWrapper.removeAttribute('data-inventory-count');
      } else {
        // Default in-stock message if we can't determine specifics or inventory count is not available
        stockLevelText.textContent = 'In stock';
        stockLevelWrapper.classList.add('stock-level--in-stock');
        stockLevelWrapper.removeAttribute('data-inventory-count');
      }
      
      // Add CSS to ensure our inventory count is always visible
      let styleEl = document.getElementById('inventory-count-styles');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'inventory-count-styles';
        document.head.appendChild(styleEl);
      }
      
      styleEl.textContent = `
        .inventory-count {
          display: inline !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
      `;
    } else {
      stockLevelText.textContent = 'Sold out';
      stockLevelWrapper.classList.add('stock-level--no-stock');
      stockLevelWrapper.removeAttribute('data-inventory-count');
    }
    
    // Remove any old custom styling we added previously
    if (document.getElementById('stock-level-styles')) {
      document.getElementById('stock-level-styles').remove();
    }
  } else {
    console.log('Stock level wrapper not found');
  }
  
  console.log('Updated stock level text for variant:', variant.title, 'to:', stockLevelText.textContent);
}


// Boost AI leftover, Boost is off: added spec table and price per TB to Boost's quick view.
// $(document).ready(function(){
//   $(document).on('click','.boost-sd__button--quick-view',function(){
//     var parent = $(this).closest('.boost-sd__product-item'),
//         url = $(parent).find('.boost-sd__product-link').attr('href');
//
//       //console.log(url);
//       $.get(url, function(data) {
//         var infor = $(data).find('.metafield-description-table').html();
//         var infromHt = '<table class="metafield-description-table">'+infor+'</table>';
//         //console.log(infor)
//         var pricePer =  '<span class="price-per pdp">'+$(data).find('.price-per.pdp').html()+'</span>';
//
//         $('#boost-sd__modal-quickview').find('.boost-sd__quick-view-price').after(pricePer+infromHt);
//     });
//   })
//
// });


// Set up a MutationObserver to watch for changes to the stock level text
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const stockLevelText = document.querySelector('.stock-level--text');
    if (stockLevelText && window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            // If we have a current variant and the text was changed by something else
            if (window.currentSelectedVariant) {
              console.log('Stock level text was changed externally, reapplying our formatting');
              
              // Check if the text was changed to just "In stock" but we have an inventory count
              const inventoryCount = stockLevelText.getAttribute('data-inventory-count');
              if (stockLevelText.textContent === 'In stock' && inventoryCount) {
                stockLevelText.textContent = `${inventoryCount} In stock`;
              } else {
                // Otherwise do a full update
                updateStockLevelText(window.currentSelectedVariant);
              }
            }
          }
        });
      });
      
      // Configure and start the observer
      observer.observe(stockLevelText, { 
        characterData: true, 
        childList: true,
        subtree: true 
      });
      
      console.log('Stock level text observer set up');
    }
  }, 1000); // Wait a second for other scripts to initialize
});

function activateMegaTab(e) {
  const tab = e.target.closest('.mega-tab');
  if (!tab) return;

  // 🔒 scope to THIS mega menu only
  const mega = tab.closest('.navmenu-meganav');
  if (!mega) return;

  const tabId = tab.getAttribute('data-tab');

  // deactivate tabs (ONLY inside this mega)
  mega.querySelectorAll('.mega-tab').forEach(t => {
    t.classList.remove('active');
    const link = t.querySelector('.mega-tab-link');
    if (link) link.removeAttribute('aria-current');
  });

  // deactivate panels (ONLY inside this mega)
  mega.querySelectorAll('.mega-panel').forEach(p => {
    p.classList.remove('active');
  });

  // activate current tab
  tab.classList.add('active');
  const activeLink = tab.querySelector('.mega-tab-link');
  if (activeLink) activeLink.setAttribute('aria-current', 'true');

  // activate matching panel
  const panel = mega.querySelector('#' + tabId);
  if (panel) {
    panel.classList.add('active');
  }
}

document.addEventListener('mouseover', activateMegaTab);
// Keyboard: Tab onto a tab link switches the panel too, so the columns match the focused tab.
document.addEventListener('focusin', activateMegaTab, true); // capture: the nav stops the bubbling event

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-toggle]');
  if (!btn) return;

  const panel = btn.nextElementSibling;
  if (!panel) return;

  const isOpen = panel.classList.contains('open');

  panel.classList.toggle('open', !isOpen);
  btn.classList.toggle('open', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
});
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-mobile-mega-toggle]');
  if (!btn) return;

  const panel = btn.nextElementSibling;
  if (!panel) return;

  const isOpen = btn.classList.contains('is-open');

  btn.classList.toggle('is-open', !isOpen);
  panel.classList.toggle('is-open', !isOpen);
});

// superstore.js opens and closes the mobile nav by class, so mirror that onto the toggle.
(function () {
  const nav = document.getElementById('site-mobile-nav');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (!nav || !toggle || !window.MutationObserver) return;
  new MutationObserver(function () {
    const open = nav.classList.contains('animating-in') || (nav.classList.contains('visible') && !nav.classList.contains('animating-out'));
    toggle.setAttribute('aria-expanded', String(open));
  }).observe(nav, { attributes: true, attributeFilter: ['class'] });
})();